import { Field } from 'formik';
import React from 'react';
import styled from 'styled-components';
import {
  BoldHeader4Text,
  Button,
  FlexRow,
  Grid,
  Icon,
  IconSize,
  IconType,
  TextInput,
  GridItem,
  PhoneNumberInput,
} from 'ui-toolkit';
import { showError } from '../../../../../utilities/order/showError';
import { IPartySchema } from '../../../../../state';
import GrayLine from '../../../../shared/GrayLine';
import { EditAddressDataEntry } from '../../../../../ui-toolkit/orders/components/EditPropertyAddress/EditAddressDataEntry';
import { IFieldChildProps } from '../../../../../ui-toolkit/utilities/formikUtilities';
import { mergeTests } from '../../../../../ui-toolkit/test-utilities/mergeTests';

interface IEditSignatoryDataEntry {
  indexOfSignatory: number;
  onClickDelete: () => void;
  autoFocus: boolean;
}

const Header = styled(BoldHeader4Text)`
  white-space: nowrap;
`;

export const EditSignatoryDataEntry: React.FC<IEditSignatoryDataEntry> = ({
  indexOfSignatory,
  onClickDelete,
  autoFocus,
}) => {
  const fieldNameStart = `signatories.${indexOfSignatory}`;
  return (
    <>
      <FlexRow>
        <Header>Signatory {indexOfSignatory + 1}</Header>
        <GrayLine />
        <Button
          intent="ghost"
          isInline
          onClick={onClickDelete}
          data-test-id={mergeTests(`signatories`, `${indexOfSignatory}`, `delete`)}
        >
          <Icon type={IconType.Remove} size={IconSize.Small} />
        </Button>
      </FlexRow>
      <Grid columnCount={8}>
        <GridItem columnStart={'span 2'}>
          <Field
            name={`${fieldNameStart}.first_name`}
            render={({ field, form }: IFieldChildProps<string, IPartySchema>) => (
              <TextInput
                {...field}
                data-test-id={field.name}
                errorText={showError(form, field.name)}
                label={`First Name`}
                onChange={(value) => form.setFieldValue(field.name, value)}
                isRequired={true}
                placeholder={'Johnny'}
                autoFocus={autoFocus}
              />
            )}
          />
        </GridItem>
        <GridItem columnStart={'span 2'}>
          <Field
            name={`${fieldNameStart}.middle_name`}
            render={({ field, form }: IFieldChildProps<string, IPartySchema>) => (
              <TextInput
                {...field}
                data-test-id={field.name}
                errorText={showError(form, field.name)}
                label={`Middle Name`}
                onChange={(value) => form.setFieldValue(field.name, value)}
                isRequired={false}
                placeholder={'"L" or "Leroy"'}
              />
            )}
          />
        </GridItem>
        <GridItem columnStart={'span 2'}>
          <Field
            name={`${fieldNameStart}.last_name`}
            render={({ field, form }: IFieldChildProps<string, IPartySchema>) => (
              <TextInput
                {...field}
                data-test-id={field.name}
                errorText={showError(form, field.name)}
                label={`Last Name`}
                onChange={(value) => form.setFieldValue(field.name, value)}
                isRequired={true}
                placeholder={'Appleseed'}
              />
            )}
          />
        </GridItem>
        <GridItem columnStart={'span 3'}>
          <Field
            name={`${fieldNameStart}.email`}
            render={({ field, form }: IFieldChildProps<string, IPartySchema>) => (
              <TextInput
                {...field}
                data-test-id={field.name}
                errorText={showError(form, field.name)}
                label={`Email`}
                onChange={(value) => form.setFieldValue(field.name, value)}
                isRequired={false}
                placeholder={'johnny@appleseed.com'}
              />
            )}
          />
        </GridItem>
        <GridItem columnStart={'span 3'}>
          <Field
            name={`${fieldNameStart}.phone_number`}
            render={({ field, form }: IFieldChildProps<string, IPartySchema>) => (
              <PhoneNumberInput
                {...field}
                errorText={showError(form, field.name)}
                label={`Phone Number`}
                isRequired={false}
                onChange={(value) => form.setFieldValue(field.name, value)}
              />
            )}
          />
        </GridItem>
        <GridItem columnStart={'span 12'}>
          <Header>Current Address</Header>
        </GridItem>
        <GridItem columnStart={'span 12'}>
          <EditAddressDataEntry name={`${fieldNameStart}.address`} />
        </GridItem>
      </Grid>
    </>
  );
};
